import {
  Avatar,
  Box,
  Button,
  Chip,
  Drawer,
  Grid2 as Grid,
  IconButton,
  Typography,
} from "@mui/material";
import { memberMenus } from "../../../components/dashboard/Sidebar/data";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../../components/dashboard/Sidebar";
import Icons from "../../../assets/js/Icons";
import { Fragment, Suspense, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Images from "../../../assets/js/Images";
import SectionSkeleton from "../../../components/ui/SectionSkeleton";
import TopBannerA from "../../../components/common/TopBannerA";

function Dashboard() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  const { member } = useSelector((state) => state.authSlice);
  const {
    appointmentUnreadCount,
    messagesUnreadCount,
  } = useSelector((state) => state.socketSlice);

  // Open mobile sidebar
  const handleClickMenu = () => {
    setMobileSidebarOpen(true);
  };

  // Close mobile sidebar
  const handleCloseMenu = () => {
    setMobileSidebarOpen(false);
  };

  // Prevent background page scrolling when mobile sidebar is open
  useEffect(() => {
  const html = document.documentElement;
  const body = document.body;

  if (mobileSidebarOpen) {
    html.style.overflow = "hidden";
    html.style.height = "100%";

    body.style.overflow = "hidden";
    body.style.height = "100%";
  } else {
    html.style.overflow = "";
    html.style.height = "";

    body.style.overflow = "";
    body.style.height = "";
  }

  return () => {
    html.style.overflow = "";
    html.style.height = "";

    body.style.overflow = "";
    body.style.height = "";
  };
}, [mobileSidebarOpen]);

  // Navigate from mobile sidebar
  const handleMenuClick = (menu) => {
    navigate(menu?.path, {
      state:
        menu?.path === "/member/profile/messages" ||
        menu?.path === "/member/profile/appointment-messages"
          ? "test"
          : null,
    });

    handleCloseMenu();
  };

  return (
    <Fragment>
      {/* =========================
          PROFILE HEADER
      ========================== */}
      <Box
        component="section"
        padding={2}
        bgcolor="#ececec"
      >
        <Box
          bgcolor="white"
          borderRadius="8px"
        >
          <Box sx={{ position: "relative" }}>
            <Suspense fallback={<SectionSkeleton />}>
              <TopBannerA
                sx={{ height: "200px" }}
                bannerImg={Images?.dashboard}
                heading="Member"
                currentPage={"member / profile"}
              />
            </Suspense>

            {/* Profile Avatar */}
            <Box
              sx={{
                p: 0.5,
                bottom: 0,
                border: "2px solid",
                position: "absolute",
                left: {
                  xs: "50%",
                  sm: "20px",
                },
                transform: {
                  xs: "translate(-50%, 50%)",
                  sm: "translateY(50%)",
                },
                borderRadius: "100px",
                borderColor: "other.color1",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Avatar
                sx={{
                  width: {
                    xs: 100,
                    md: 150,
                    xl: 180,
                  },
                  height: {
                    xs: 100,
                    md: 150,
                    xl: 180,
                  },
                }}
                src={member?.image}
              />
            </Box>
          </Box>

          {/* Profile Details */}
          <Box
            sx={{
              py: 2,
              pr: "20px",
              minHeight: {
                xs: "66px",
                md: "91px",
                xl: "106px",
              },
              pl: {
                xs: "20px",
                md: "200px",
                xl: "230px",
              },
              pt: {
                xs: "4rem",
              },
            }}
          >
            <Grid
              container
              spacing={2}
              alignItems="center"
            >
              <Grid size={{ xs: 12, md: "grow" }}>
                <Typography
                  fontSize={36}
                  component="h6"
                  lineHeight="1.2"
                  fontWeight="600"
                  color="other.color1"
                  textTransform="capitalize"
                >
                  {member?.fullName}
                </Typography>

                <Typography
                  fontSize={18}
                  fontWeight="500"
                  lineHeight="1.2"
                  color="other.color1"
                >
                  {member?.email}
                </Typography>
              </Grid>

              <Grid size={{ xs: 12, md: "auto" }}>
                <Box
                  sx={{
                    gap: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  {/* Edit Profile */}
                  <Button
                    color="primary"
                    variant="contained"
                    LinkComponent={Link}
                    to="/member/profile/edit-profile"
                  >
                    Edit Profile
                  </Button>

                  {/* Mobile Menu Button */}
                  <IconButton
                    onClick={handleClickMenu}
                    sx={{
                      display: {
                        xs: "flex",
                        lg: "none",
                      },
                    }}
                  >
                    <Icons.Menu />
                  </IconButton>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>

      {/* =========================
          DASHBOARD CONTENT
      ========================== */}
      <Box
        sx={{
          p: 2,
          bgcolor: "#ececec",
        }}
        component="section"
      >
        <Grid
          container
          spacing={3}
          alignItems="stretch"
        >
          {/* Desktop Sidebar */}
          <Grid
            size="auto"
            sx={{
              display: {
                xs: "none",
                lg: "block",
              },
            }}
          >
            <Sidebar menus={memberMenus} />
          </Grid>

          {/* Main Content */}
          <Grid
            size={{
              xs: 12,
              md: "grow",
            }}
          >
            <Box
              sx={{
                p: 3,
                height: "100%",
                bgcolor: "white",
                borderRadius: "8px",
              }}
            >
              <Outlet />
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* =========================
          MOBILE SIDEBAR DRAWER
      ========================== */}
      <Drawer
        anchor="left"
        open={mobileSidebarOpen}
        onClose={handleCloseMenu}
        sx={{
          display: {
            xs: "block",
            lg: "none",
          },

          "& .MuiDrawer-paper": {
            width: {
              xs: "85%",
              sm: "320px",
            },
            maxWidth: "320px",
            boxSizing: "border-box",
            overflowY: "auto",
            overflowX: "hidden",
            p: 2,
          },
        }}
      >
        {/* Drawer Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          <Typography
            fontSize={20}
            fontWeight={600}
            color="other.color1"
          >
            Member Menu
          </Typography>

          <IconButton onClick={handleCloseMenu}>
            <Typography
              component="span"
              fontSize={28}
              lineHeight={1}
            >
              ×
            </Typography>
          </IconButton>
        </Box>

        {/* Mobile Menu Items */}
        <Box>
          {memberMenus?.map((menu, i) => {
            const isAppointmentChat =
              menu?.name?.toLowerCase() === "appointment chat" ||
              menu?.path?.includes("appointment-messages");

            const isGeneralMessages =
              menu?.name?.toLowerCase() === "messages" ||
              (menu?.path?.includes("/messages") &&
                !menu?.path?.includes("appointment-messages"));

            const isActive = menu?.path === pathname;

            return (
              <Box
                key={i}
                onClick={() => handleMenuClick(menu)}
                sx={{
                  width: "100%",
                  minHeight: "48px",
                  px: 1.5,
                  py: 1,
                  mb: 0.5,
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  cursor: "pointer",
                  borderRadius: "8px",
                  bgcolor: isActive
                    ? "#2f425017"
                    : "transparent",

                  "&:hover": {
                    bgcolor: "#2f425017",
                  },
                }}
              >
                {/* Menu Icon */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {menu?.icon}
                </Box>

                {/* Menu Name */}
                <Typography
                  sx={{
                    flex: 1,
                    fontSize: "15px",
                    fontWeight: "400",
                    color: "other.color2",
                    fontFamily: "Poppins",
                    textTransform: "capitalize",
                  }}
                >
                  {menu?.name}
                </Typography>

                {/* Appointment Unread Count */}
                {isAppointmentChat &&
                  appointmentUnreadCount > 0 && (
                    <Chip
                      label={
                        appointmentUnreadCount > 99
                          ? "99+"
                          : appointmentUnreadCount
                      }
                      size="small"
                      color="error"
                      sx={{
                        height: 20,
                        fontSize: "11px",
                        fontWeight: 600,
                        fontFamily: "Poppins",
                      }}
                    />
                  )}

                {/* General Messages Unread Count */}
                {isGeneralMessages &&
                  messagesUnreadCount > 0 && (
                    <Chip
                      label={
                        messagesUnreadCount > 99
                          ? "99+"
                          : messagesUnreadCount
                      }
                      size="small"
                      color="error"
                      sx={{
                        height: 20,
                        fontSize: "11px",
                        fontWeight: 600,
                        fontFamily: "Poppins",
                      }}
                    />
                  )}
              </Box>
            );
          })}
        </Box>
      </Drawer>
    </Fragment>
  );
}

export default Dashboard;